import axios from '@core/services/axios';
import {Api} from '@common/constants';
import store from '@store';
import type {InputComponentActivation} from '../components/InputActivationSection/inputActivationApi';

export type UpdateInputComponentPayload = {
  componentId?: string;
  workflowId?: string;
  type?: string;
  name?: string;
  description?: string | null;
  storeAs?: string | null;
  version?: number;
  inputSchema?: Record<string, unknown>;
  inputReferenceKey?: string | null;
  constants?: Record<string, unknown> | null;
  activation?: InputComponentActivation;
  nextComponentId?: string | null;
  deleted?: boolean;
};

const getCurrentWorkflowId = (): string => {
  const state = store.getState();
  const workflowId = state.ruleDetailWorkflow?.workflowId;
  if (!workflowId) {
    throw new Error(
      'No current workflow found in store. Please set workflowId first.'
    );
  }
  return workflowId;
};

const getTenantId = () => store.getState().auth?.user?.tenantId;

export async function updateInputComponent(
  inputId: string,
  payload: UpdateInputComponentPayload
) {
  const tenantId = getTenantId();
  const workflowId = getCurrentWorkflowId();
  const response = await axios.put(
    `${Api.RULE_ENGINE_BASE_URL}/workflows/${workflowId}/input/${inputId}`,
    payload,
    {
      headers: {'X-Tenant-ID': tenantId},
    }
  );
  return response.data;
}

export async function fetchInputComponent(inputId: string) {
  const tenantId = getTenantId();
  const workflowId = getCurrentWorkflowId();
  const response = await axios.get(
    `${Api.RULE_ENGINE_BASE_URL}/workflows/${workflowId}/input/${inputId}`,
    {
      headers: {'X-Tenant-ID': tenantId},
    }
  );
  return response.data;
}
